<template>
<div>
  <div class="horizontal">
    <div class="left">会社名</div>
    <div class="right">{{ item.data.companyName }}</div>
  </div>
  <div class="horizontal">
    <div class="left">設立年</div>
    <div class="right">{{ $planConfig.dateIntFormat(item.data.establishedDate) }}</div>
  </div>
  <div class="horizontal">
    <div class="left">代表取締役</div>
    <div class="right">{{ item.data.ceo }}</div>
  </div>
  <div class="horizontal">
    <div class="left">資本金</div>
    <div class="right">{{ item.data.capital }}</div>
  </div>
  <div class="horizontal">
    <div class="left">所在地</div>
    <div class="right">{{ item.data.address.postalCode }}
      {{ item.data.address.postalDetail }}
    </div>
  </div>
  <div class="horizontal">
    <div class="left">電話番号</div>
    <div class="right">{{ item.data.tel }}</div>
  </div>
  <div class="horizontal">
    <div class="left">WEBサイトURL</div>
    <div class="right">{{ item.data.url }}</div>
  </div>
  <div class="horizontal">
    <div class="left">事業内容</div>
    <div class="right">{{ item.data.businessContentsSimple }}</div>
  </div>
  <expert-comment v-bind:item="item"
    v-if="isConsultationPlan"
    v-bind:groupIndex="groupIndex"
    v-bind:itemIndex="itemIndex"
    v-bind:isEditableComment="isEditableComment"></expert-comment>
  </div>
  </template>

  <script>
  import expertComment from '@/components/parts/ExpertComment'
  export default {
  components: {
    'expert-comment': expertComment
  },
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isConsultationPlan', 'isEditableComment'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
